// Helper to generate Escher-signed URLs for local development only
// DO NOT USE IN PRODUCTION

import Escher from "escher-auth";

const escherConfig = {
  algoPrefix: "EMS",
  vendorKey: "EMS",
  hashAlgo: "SHA256",
  credentialScope: "eu/loyalsys/ems_request",
  authHeaderName: "X-EMS-Auth",
  dateHeaderName: "X-EMS-Date",
  clockSkew: 300,
  apiSecret: process.env.REACT_APP_ESCHER_SECRET,
  accessKeyId: process.env.REACT_APP_ESCHER_KEY
};

const accessKeyId = process.env.REACT_APP_ESCHER_KEY;
const apiSecret = process.env.REACT_APP_ESCHER_SECRET;

export function generateEscherSignedUrl(url, method = "GET", expires = 300) {
  let escher;
  try {
    escher = new Escher(escherConfig);
  } catch (error) {
    console.error("Error creating Escher instance:", error);
  }
  // Always sign the 'host' header, as in the Go example
  const headersToSign = ["host"];
  let preSignUrl;
  try {
    preSignUrl = escher.preSignUrl(url, expires, accessKeyId, apiSecret, method, headersToSign);
  } catch (error) {
    console.error("Error generating pre-signed URL:", error);
  }
  return preSignUrl;
}
